import TimelineIcon from "@mui/icons-material/Timeline";
import CollectionsIcon from "@mui/icons-material/Collections";
import PeopleIcon from "@mui/icons-material/People";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import {
  FamilyRestroom,
  EscalatorWarning,
  Campaign,
  BabyChangingStation,
  Diversity3,
  CalendarMonth,
  AutoGraph,
  RestaurantMenu,
} from "@mui/icons-material";

interface NavigationItemConfig {
  label: string;
  icon?: React.ComponentType;
  to?: string;
  type?: string;
  role?: string[];
}

export const navigationConfig: NavigationItemConfig[] = [
  {
    type: "item",
    label: "timeline",
    role: ["PARENT", "NURSERY_ADMIN", "ROOM_LEADER", "NURSERY_PRACTITIONER"],
    icon: TimelineIcon,
    to: "/timeline",
  },
  {
    type: "item",
    label: "gallery",
    role: ["PARENT", "NURSERY_ADMIN", "ROOM_LEADER", "NURSERY_PRACTITIONER"],
    icon: CollectionsIcon,
    to: "/gallery",
  },
  {
    type: "item",
    label: "children",
    role: ["PARENT"],
    icon: PeopleIcon,
    to: "/children",
  },
  {
    type: "item",
    label: "attendance",
    role: ["PARENT", "ROOM_LEADER", "NURSERY_PRACTITIONER", "NURSERY_ADMIN"],
    icon: CalendarMonth,
    to: "/attendance",
  },
  {
    type: "item",
    label: "parents",
    role: ["NURSERY_ADMIN", "ROOM_LEADER", "NURSERY_PRACTITIONER"],
    icon: FamilyRestroom,
    to: "/parents",
  },
  {
    type: "item",
    label: "child",
    role: ["NURSERY_ADMIN", "ROOM_LEADER", "NURSERY_PRACTITIONER"],
    icon: EscalatorWarning,
    to: "/child",
  },
  {
    type: "item",
    label: "staff",
    role: ["NURSERY_ADMIN"],
    icon: BabyChangingStation,
    to: "/nursery",
  },
  {
    type: "item",
    label: "classroom",
    role: ["NURSERY_ADMIN", "ROOM_LEADER", "NURSERY_PRACTITIONER"],
    icon: Diversity3,
    to: "/class",
  },
  {
    type: "item",
    label: "newsletter",
    role: ["PARENT", "NURSERY_ADMIN", "ROOM_LEADER", "NURSERY_PRACTITIONER"],
    icon: Campaign,
    to: "/newsletter",
  },
  {
    type: "item",
    label: "menu",
    role: ["PARENT", "NURSERY_ADMIN", "ROOM_LEADER", "NURSERY_PRACTITIONER"],
    icon: RestaurantMenu,
    to: "/menu",
  },
  {
    type: "item",
    label: "grading",
    role: ["NURSERY_ADMIN", "ROOM_LEADER", "NURSERY_PRACTITIONER"],
    icon: AutoGraph,
    to: "/grading",
  },
  {
    type: "item",
    label: "finance",
    role: ["PARENT", "NURSERY_ADMIN"],
    icon: CreditCardIcon,
    to: "/finance",
  },
];
